import { EAssetType } from 'constants/enums';
import { GradientColor, OfferDesignFormValues, UniqueFlag } from 'views/OfferDesign/OfferDesign.types';

export type Spacing = 'none' | 'sm' | 'md' | 'lg' | 'xl';

export const SPACING_MAP: Record<Spacing, string> = {
  none: '',
  sm: 'mt-4',
  md: 'mt-5',
  lg: 'mt-9',
  xl: 'mt-14'
};

export type FieldLayout = 'full' | 'half' | 'flex';

export const FIELD_LAYOUT_MAP: Record<FieldLayout, string> = {
  full: '',
  half: 'w-1/2',
  flex: 'flex-1'
};

export type TextFieldConfig = {
  label: string;
  name: string;
  placeholder: string;
  defaultValue?: string;
  maxLength?: number;
  uniqueFlag?: UniqueFlag;
};

export type UploadFieldConfig = {
  title: string;
  fieldName: string;
  forceType: EAssetType;
  tooltip: string;
  isRequired?: boolean;
  disabled?: (values: OfferDesignFormValues) => boolean;
};

export type GradientFieldConfig = {
  header: string;
  name: string;
  fallback: Readonly<GradientColor>;
  required?: boolean;
  dataTestId?: string;
};

export type NumberFieldConfig = {
  label: string;
  name: string;
  min?: number;
  max?: number;
  isRequired?: boolean;
  leftIcon?: React.ReactElement;
  leftIconStyles?: string;
};
